import styled from "styled-components";

export const Container = styled.footer`
  background-color: #2b2b2b;
  padding: 2rem 10rem;
  margin-top: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #ffffff;

  .footer-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
  }

  .social-media {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;

    a {
      text-decoration: none;
      color: #ffffff;

      img {
        width: 3rem;
        transition: transform 0.3s ease-in-out;
      }

      &:hover img {
        transform: scale(1.1);
      }
    }
  }

  p {
    margin: 1rem 0;
    font-size: 1.2rem;
    text-align: center;
  }

  .footer-links {
    display: flex;
    gap: 1.5rem;

    a {
      color: #ffffff;
      font-size: 1.1rem;
      text-decoration: none;
      transition: color 0.3s ease-in-out;

      &:hover {
        color: #d90166; /* Accent color */
      }
    }
  }

  @media(max-width: 800px) {
    padding: 2rem 5rem;
    
    .footer-content {
      gap: 1.5rem;
    }
  }

  @media(max-width: 600px) {
    padding: 2rem 1rem;
    text-align: center;
    
    .social-media {
      gap: 1rem;

      img {
        width: 2.2rem;
      }
    }

    p {
      font-size: 1rem;
    }

    .footer-links {
      flex-direction: column;
      gap: 1rem;
    }
  }
`;
